module.exports = __webpack_public_path__ + "media/illustrations/anuncio-celular-835b1a70.svg";